import { WatchAccountService } from '../../../../services/watch-account.service';
import { AccountService } from '../../../../services/account.service';
import { Component } from '@angular/core';
import { WatchFunnelService } from '../../../../services/watch-funnel.service';
import { FunnelService } from '../../../../services/funnel.service';
import { Subscription, Observable } from 'rxjs';
import { IFunnel, ITimeTable } from '../../../../interfaces/graph-types';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';

@Component({
  selector: '[account-funnel-settings]',
  template: require('./account-funnel-settings.component.pug'),
  styles: [require('./account-funnel-settings.component.css').toString()],
})
export class AccountFunnelSettingsComponent {
  // -------------------------------------------------------------------
  constructor(
    private watchFunnel: WatchFunnelService,
    private funnelService: FunnelService,
    private accountService: AccountService,
    private modalService: BsModalService,
    private router: Router,
    private watchAccount: WatchAccountService,
  ) {}

  funnel: IFunnel;
  sub: Subscription;
  subReason: Subscription = null;
  bsModalRef: BsModalRef;
  timetables$: Observable<ITimeTable[]>;
  timeTableId = null;

  allowOptionLabel =
    "By default, as a security measure, a candidate can't start the same funnel. Tick this box to allow for such behaviour.";

  addedToLibraryLabel =
    'This will make this funnel available to be used as a template to create a new funnel.';

  // -------------------------------------------------------------------
  ngOnInit(): void {
    this.timetables$ = this.accountService.timetables(
      this.watchAccount.accountId().getValue(),
    );

    let funnelId = this.watchFunnel.funnelId().getValue();
    this.sub = this.funnelService.funnelSettings(funnelId).subscribe(res => {
      this.funnel = res;
      if (this.funnel && this.funnel.timeTable) {
        this.timeTableId = this.funnel.timeTable.id;
      }
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    this.sub.unsubscribe();
    if (this.subReason) {
      this.subReason.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  changeAttributeDetected(
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.funnelService.setAttributeValue(
      this.watchFunnel.funnelId().getValue(),
      data.id,
      newValue,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
    //console.warn(this.candidate);
  }

  errorSharing: string;

  // -------------------------------------------------------------------
  changeSharing(value) {
    let account_id = this.watchFunnel.funnelId().getValue();

    this.errorSharing = '';

    this.funnelService.setSettings(
      account_id,
      'sharing',
      value,
      result => {
        this.funnel.sharing = value;
        //onsuccess();
      },
      error => {
        this.errorSharing = error;
      },
    );
  }

  errorTimeTable: string;

  // -------------------------------------------------------------------
  changeTimeTable(value) {
    let account_id = this.watchFunnel.funnelId().getValue();

    this.errorTimeTable = '';

    this.funnelService.setSettings(
      account_id,
      'time_table',
      value,
      result => {
        //this.timeTableId = value;
        //onsuccess();
      },
      error => {
        this.errorTimeTable = error;
      },
    );
  }

  // -------------------------------------------------------------------
  unsubHeader(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let account_id = this.watchFunnel.funnelId().getValue();
    let newstate = !this.funnel.unsubscribeHeader;
    console.warn({ newstate });

    this.funnelService.setSettings(
      account_id,
      'unsubscribe_header',
      newstate.toString(),
      result => {
        this.funnel.unsubscribeHeader = result.status === 'true';
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  cancelColleagues(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    let account_id = this.watchFunnel.funnelId().getValue();
    let newstate = !this.funnel.cancelColleagues;
    console.warn({ newstate });

    this.funnelService.setSettings(
      account_id,
      'cancel_colleagues',
      newstate.toString(),
      result => {
        this.funnel.cancelColleagues = result.status === 'true';
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  continueOnReply(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    let account_id = this.watchFunnel.funnelId().getValue();
    let newstate = !this.funnel.continueOnReply;
    console.warn({ newstate });

    this.funnelService.setSettings(
      account_id,
      'continue_on_reply',
      newstate.toString(),
      result => {
        this.funnel.continueOnReply = result.status === 'true';
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  enableCaptureForm(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    let account_id = this.watchFunnel.funnelId().getValue();
    let newstate = !this.funnel.enableCaptureForm;

    this.funnelService.setSettings(
      account_id,
      'enable_capture_form',
      newstate.toString(),
      result => {
        this.funnel.enableCaptureForm = result.status === 'true';
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  reEnter(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let account_id = this.watchFunnel.funnelId().getValue();
    let newstate = !this.funnel.allowReenter;
    console.warn({ newstate });

    this.funnelService.setSettings(
      account_id,
      'allow_reenter',
      newstate.toString(),
      result => {
        this.funnel.allowReenter = result.status === 'true';
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  addedToLibrary(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    let account_id = this.watchFunnel.funnelId().getValue();
    let newstate = !this.funnel.addedToLibrary;
    console.warn({ newstate });

    this.funnelService.setSettings(
      account_id,
      'added_to_library',
      newstate.toString(),
      result => {
        this.funnel.addedToLibrary = result.status === 'true';
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  recomputeStatsRequestMade = false;
  // -------------------------------------------------------------------
  recomputeStats(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.funnelService.recomputeFunnelStats(
      this.funnel.id,
      res => {
        this.recomputeStatsRequestMade = true;
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  cloneFunnel(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    const now = new Date();
    const secondsSinceEpoch = Math.round(now.getTime() / 1000);

    this.funnelService.clone(
      this.funnel.id,
      this.funnel.name + '(copy) - ' + secondsSinceEpoch.toString(),
      res => {
        this.router.navigate([
          '/account/' +
            this.watchAccount.accountId().getValue() +
            '/funnels/' +
            res.funnelId.toString(),
        ]);
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  toggleArchive(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    let newstate = !this.funnel.archived;

    this.funnelService.setArchived(
      this.funnel.id,
      newstate,
      () => {
        this.funnel.archived = newstate;
        if (this.funnel.archived) {
          this.funnel.live = false;
        }
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  confirmDelete(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.accountService.deleteFunnel(
      this.watchFunnel.funnelId().getValue(),
      result => {
        this.router.navigate([
          '/account/' + this.watchAccount.accountId().getValue() + '/funnels/',
        ]);
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  changeNameDetected(
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.funnelService.setSettings(
      this.watchFunnel.funnelId().getValue(),
      'name',
      newValue,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
  // -------------------------------------------------------------------
  changeDescriptionDetected(
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.funnelService.setSettings(
      this.watchFunnel.funnelId().getValue(),
      'description',
      newValue,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }
}
